"use client";

import { useAtomValue } from "jotai";
import { useTranslations } from "next-intl";
import React, { type ReactElement } from "react";
import { siteCountAtom } from "@/store/home";

function HomeStatSite(): ReactElement | null {
  const t = useTranslations("home.StatSite");
  const count = useAtomValue(siteCountAtom);

  if (!count) return null;

  return (
    <div className="p-0 flex flex-row gap-2">
      <span className="font-mono text-3xl text-teal-300">{count}</span>
      <span className="text-sm text-teal-500">
        {t("label", { count: count })}
      </span>
    </div>
  );
}

export { HomeStatSite };
